import React, { useState, useEffect } from 'react';
import { GET_MEMBERSHIP_DATA, PURCHASE_MEMBERSHIP, PRODUCT_IDS, SERVER_IMAGE_API_URL } from "../helpers/Constant";
import { getDataWithToken } from '../api/api';
import { useTranslation } from 'react-i18next';
import Loader from '../common/loader';
import BackButton from '../common/backButton';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { postDataWithToken } from '../api/api';
import { checkAuth, getUserInfo } from '../utils/common';

function Membership() {
    const { t } = useTranslation();
    const [userData, setUserData] = useState(getUserInfo());
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [membershipFeatures, setMembershipFeatures] = useState([]);
    const [monthlyPlan, setMonthlyPlan] = useState(0);
    const [annualPlan, setAnnualPlan] = useState(0);
    const [selectedMembershipPlan, setSelectedMembershipPlan] = useState("");
    const [loading, setLoading] = useState(true);
    
    const options = {
        pagination: true,
        type: 'loop',
        autoplay: false,
        speed: 500,
        perPage: 2,
        perMove: 1,
        arrows: false,
    };

    useEffect(() => {
        async function fetchMembershipData() {
            try {
                const response = await getDataWithToken(GET_MEMBERSHIP_DATA);
                if(response) {
                   if(response.membership_annual_fee) {
                    setAnnualPlan(response.membership_annual_fee);
                   }
                   if(response.membership_monthly_fee) {
                    setMonthlyPlan(response.membership_monthly_fee);
                   }
                   if(response.membership_features) {
                    setMembershipFeatures(response.membership_features);
                   }
                } else {
                    setMembershipFeatures([]);
                }
                setLoading(false);
            } catch (error) {
                setLoading(false);
            }
        }
        fetchMembershipData()
    }, []);

    const handleBuyMonthlyMembership = (plan) => {
        setErrorMessage("");
        setLoading(true);
        setSelectedMembershipPlan("monthly");
        const url = `uniwebview://buyRequest?itemBundleID=${PRODUCT_IDS.MONTHLY_SUBSCRIPTION}`;
        window.location.href = url;
    }

    const handleBuyAnnualMembership = (plan) => {
        setErrorMessage("");
        setLoading(true);
        setSelectedMembershipPlan("annual");
        const url = `uniwebview://buyRequest?itemBundleID=${PRODUCT_IDS.YEARLY_SUBSCRIPTION}`;
        window.location.href = url;
    }

    const refreshUserData = async () => {
        const response = await checkAuth();
        if(response){
            setUserData(response);
        }
    }

    const handleBuyMembership = async (purchaseToken, platform) => {
        setLoading(true);
        const response = await postDataWithToken(PURCHASE_MEMBERSHIP, { membershipPlan: selectedMembershipPlan, purchaseToken: purchaseToken, platform: platform });
        if(response?.data){
            refreshUserData();
            setSuccessMessage("Membership purchased successfully. You are prime user now.");
        } else {
            setErrorMessage(response?.message || "Something went wrong. Please try again.");
        }
        setLoading(false);
    }

    window.buyRequestSuccess = (payloadOrToken, platformArg) => {
        setLoading(false);
        let data = payloadOrToken;
        if (typeof data === 'string') {
            try {
                data = JSON.parse(data);
            } catch {}
        }
        
        const isObjectPayload = data && typeof data === 'object' && !Array.isArray(data);
        const purchaseToken = isObjectPayload ? (data.token ?? data.purchaseToken) : data;
        const platform = isObjectPayload ? data.platform : platformArg;

        if (purchaseToken != null && platform != null) {
            handleBuyMembership(purchaseToken, platform);
        }
    };

    window.buyRequestFailed = (itemBundleID) => {
        setErrorMessage("Your payment failed. Please try again.");
        setTimeout(() => {
            setErrorMessage("");
        }, 3000);
        setLoading(false);
    }

    return (
        <>
            <div className='wrapper h-100 px-0'>
                {loading && <Loader />}

                <div className="px-3">
                    <BackButton label={t('Home')} />
                </div>

                <div className='membership_wrapper'>
                    <div className='membership_heading_wrapper position-relative'>
                        <div className='membership_heading text-center position-relative z-1'>
                            <h1 className='membership_title fw-bold mb-0'>{t('MUVE ELITE')}</h1>
                        </div>
                        <div className='membership_round_wrapper position-absolute top-50 start-50 translate-middle'>
                            <div className='membership_round membership_round_1 rounded-pill pe-none position-absolute top-50 start-50 translate-middle'></div>
                            <div className='membership_round membership_round_2 rounded-pill pe-none position-absolute top-50 start-50 translate-middle'></div>
                            <div className='membership_round membership_round_3 rounded-pill pe-none position-absolute top-50 start-50 translate-middle'></div>
                            <div className='membership_round membership_round_4 rounded-pill pe-none position-absolute top-50 start-50 translate-middle'></div>
                        </div>
                    </div>
                    <div className='pt-1 text-center position-relative z-1'>
                        <div className='membership_role d-inline-block fw-medium rounded-corners text-uppercase py-1 px-3 mb-1'>Premium</div>
                        <h4 className='membership_unlock fw-light p-2 mt-3 mb-4'>Unlock Your Full Movement Potential</h4>
                    </div>
                    <Splide options={options}>
                        {Array.from({ length: Math.ceil(membershipFeatures.length / 2) }, (_, pairIndex) => {
                            const first = membershipFeatures[pairIndex * 2];
                            const second = membershipFeatures[pairIndex * 2 + 1];
                            return (
                                <SplideSlide key={pairIndex}>
                                    <div className='membership_item'>
                                        <div className='membership_card'>
                                            <div className='membership_card_image'>
                                                <img src={`${SERVER_IMAGE_API_URL}${first.image}`} alt='Ticket' />
                                            </div>
                                            <h4 className='membership_card_title fw-medium mb-0 px-2 pb-3'>{first.title}</h4>
                                        </div>
                                        {second && (
                                            <div className='membership_card'>
                                                <div className='membership_card_image'>
                                                    <img src={`${SERVER_IMAGE_API_URL}${second.image}`} alt='Ticket' />
                                                </div>
                                                <h4 className='membership_card_title fw-medium mb-0 px-2 pb-3'>{second.title}</h4>
                                            </div>
                                        )}
                                    </div>
                                </SplideSlide>
                            );
                        })}
                    </Splide>
                    <div className='membership_feedback fw-light text-center mt-3'>Premium Access. <br/>Maximum results. Zero limits.</div>

                    {errorMessage && <div className='membership_error error_message text-center mb-3'>{errorMessage}</div>}
                    {
                    successMessage ? 
                        <div className='membership_success px-2 text-center mt-3'>{successMessage}</div> 
                    : userData?.userAccount?.isPrimeUser ? 
                        <div className='membership_default px-2 text-center mt-3'>You are already a member.</div>
                    : 
                        <div className='membership_btn d-flex flex-column align-items-center gap-3 mt-4 px-3'>
                            <button className='membership_button fw-bold d-flex justify-content-between w-100' onClick={handleBuyMonthlyMembership}>
                                <div className='membership_button_left d-flex flex-column justify-content-center align-items-start'>
                                    <span className='membership_button_month'>1 month</span>
                                </div>
                                <div className='membership_button_right d-flex flex-column justify-content-center align-items-end'>
                                    <span className='membership_button_price'>$ {monthlyPlan || 9.99}</span>
                                </div>
                            </button>
                            <button className='membership_button fw-bold d-flex justify-content-between w-100' onClick={handleBuyAnnualMembership}>
                                <div className='membership_button_left d-flex flex-column justify-content-center align-items-start'>
                                    <span className='membership_button_month'>12 month</span>
                                    <span className='membership_button_role d-inline-block fw-medium rounded-corners text-uppercase'>Popular</span>
                                </div>
                                <div className='membership_button_right d-flex flex-column justify-content-center align-items-end'>
                                    <span className='membership_button_old_price text-uppercase'><del>$ {parseFloat(monthlyPlan || 9.99) * 12 || 99.99}</del></span>
                                    <span className='membership_button_price'>$ {annualPlan || 59.99}</span>
                                </div>
                            </button>
                        </div>
                    }
                </div>
            </div>
        </>
    );
}
export default Membership